import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Browser = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 10H23C23.552 10 24 9.552 24 9C24 8.448 23.552 8 23 8H17C16.448 8 16 8.448 16 9C16 9.552 16.448 10 17 10Z" />
		<path d="M23 4H9C6.243 4 4 6.243 4 9V23C4 25.757 6.243 28 9 28H23C25.757 28 28 25.757 28 23V9C28 6.243 25.757 4 23 4ZM9 6H23C24.654 6 26 7.346 26 9V12H6V9C6 7.346 7.346 6 9 6ZM23 26H9C7.346 26 6 24.654 6 23V14H26V23C26 24.654 24.654 26 23 26Z" />
		<path d="M14 9C14 9.552 13.552 10 13 10C12.448 10 12 9.552 12 9C12 8.448 12.448 8 13 8C13.552 8 14 8.448 14 9Z" />
		<path d="M10 9C10 9.552 9.552 10 9 10C8.448 10 8 9.552 8 9C8 8.448 8.448 8 9 8C9.552 8 10 8.448 10 9Z" />
	</svg>
);

export default Browser;
